import script from "./HllProductComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HllProductComponent.vue?vue&type=script&setup=true&lang=js"

import "./HllProductComponent.vue?vue&type=style&index=0&id=5c008b7e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c008b7e"]])

export default __exports__